/* global App */

(function () {
    var kilo = Math.pow(10, 3);
    var mega = Math.pow(10, 6);
    var giga = Math.pow(10, 9);
    var tera = Math.pow(10, 12);
    App.Helpers = {
        number: function (value) {
            if (value === null) return null;
            value = value || 0;
            if (value >= tera) {
                return value / tera;
            }
            if (value >= giga) {
                return value / giga;
            }
            if (value >= mega) {
                return value / mega;
            }
            if (value >= kilo) {
                return value / kilo;
            }
            return value;
        },
        numberWithUnit: function (value, unit) {
            if (value === null) return "";
            value = value || 0;
            unit = unit || "";
            if (value >= tera) {
                value = value / tera;
                return value.toFixed(1) + " T" + unit;
            }
            if (value >= giga) {
                value = value / giga;
                return value.toFixed(1) + " G" + unit;
            }
            if (value >= mega) {
                value = value / mega;
                return value.toFixed(1) + " M" + unit;
            }
            if (value >= kilo) {
                value = value / kilo;
                return value.toFixed(1) + " k" + unit;
            }
            return value.toFixed(1) + " " + unit;
        }
    };
})();
